<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>

    <el-dialog title="PDF列表" :visible.sync="dialogMultPdf" width="30%">
      <div class="mainPDF" :key="index" v-for="(item, index) in dialogPdfArr">
        <label>{{ item.sign_name }}</label>
        <img
          @click="goPage(item)"
          style="width: 60px; height: auto; cursor: pointer"
          src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xladmin/static/icon_pdf.png"
        />
      </div>
    </el-dialog>

    <PageHeaderLayout v-show="$route.matched.length == 2" :isBack="query.task_id">
      <div class="main-page-content">
        <el-row class="table-header-gai">
          <el-col>
            <!-- <el-button
              v-if="userPermissions.indexOf('customer_sign') != -1"
              size="medium"
              type="primary"
              class="cusomer-link-gai"
              @click="cusomerLink"
              icon="el-icon-paperclip"
              >生成合作邀请码
            </el-button> -->
			<el-button
              v-if="showLinkBtn"
              size="medium"
              type="primary"
              class="cusomer-link-search"
              @click="showQyLink"
              >
              查询签约链接
			</el-button>
          </el-col>
          <el-col>
            <div
              type="primary"
              size="medium"
              class="total-num"
              @click="cusomerLink"
            >
              已签约人数：<span class="span-num">{{
                this.pagingData.total
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="height: 36px">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="姓名">
              <el-input
                v-model="searchCondition.fullname"
                placeholder="输入姓名"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="签约类型">
              <el-select
                v-model="searchCondition.sign_type"
                filterable
                clearable
                :multiple-limit="1"
                placeholder="请选择"
                class="selectWord"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码">
              <el-input
                v-model="searchCondition.id_number"
                placeholder="输入证件号码"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
            <div class="table-right">
			<el-form-item>
				<el-button
					:loading="sign_downloadLoading"
					type="primary"
					icon="el-icon-document"
					@click="handleDownload_sign"
				>
					批量下载协议
				</el-button>
			</el-form-item>
              <el-form-item>
                <el-select
                  v-model="exportSelect"
                  @change="changeExportOption"
                  class="select-box"
                >
                  <el-option
                    v-for="item in exportOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="downloadLoading"
                  type="primary"
                  icon="el-icon-document"
                  @click="handleDownload"
                >
                  导出
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-row>
		
		<!-- 生成签约链接的dialog模态框 -->
		<el-dialog
		title="查询签约链接"
		:visible.sync="showQyLinkVisible"
		width="40%"
		>
		<el-form>
			<el-form-item label="手机号">
				<el-input
				v-model="qyLinkForm.mobile"
				maxlength="11"
				placeholder="请输入手机号"
				class="item-mobile"
				clearable
				></el-input>
				<el-button class="searchBtnQYLink" type="primary" @click="event_searchLink">查询</el-button>
			</el-form-item>
			<el-form-item label="签约链接">
				<div class="qyLinkArea">
					<div class="linkurl" v-if="qyLinkForm.url">{{qyLinkForm.url}}</div>
					<div v-else class="linkurl-nodata">暂无签约链接</div>
					<el-button v-if="qyLinkForm.url" class="searchBtnQYLink" type="text" @click="copyLink">复制链接</el-button>
				</div>
			</el-form-item>
		</el-form>
		</el-dialog>

        <!-- 生成签约链接的dialog模态框 -->
        <el-dialog
          title="生成合作邀请码"
          :visible.sync="outerVisible"
          :before-close="handleOuterClose"
          width="40%"
        >
          <el-form size="medium" :inline="true" :model="searchCondition">
            <!-- <el-form-item label="任务类型" prop="desc" id="desc">
              <el-select v-model="companyFormData.id" filterable placeholder="请选择任务类型" value-key="id" multiple @change="getCategory">
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="请选择任务类型" prop="desc" id="desc">
              <el-checkbox-group
                v-model="companyFormData.name"
                size="small"
                @change="handleTaskChange"
                :max="10"
              >
                <el-checkbox
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  border
                >
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-checkbox v-model="showDesc">任务描述</el-checkbox>
            <div v-show="showDesc" style="color: #606266; height: 1.5rem; line-height: 1.5rem">
              {{ missionContentWarn }}
            </div>
            <el-input
              v-show="showDesc"
              type="textarea"
              rows="6"
              placeholder="请输入任务描述"
              maxlength="200"
              show-word-limit
              v-model="companyFormData.missionContent"
            >
            </el-input>
          </el-form>
          <!-- <el-dialog
            width="25%"
            :title="'生成签约链接'"
            :close-on-click-modal="false"
            :visible.sync="innerVisible"
            :before-close="handleInnerClose"
            append-to-body>
            <div class="link-title">请复制以下链接到手机预览</div>
            <div>{{this.signUrl}}</div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="goSign" size="medium">确定</el-button>
            </div>
          </el-dialog> -->

          <el-dialog
            width="40%"
            :title="'系统提示'"
            :close-on-click-modal="false"
            :visible.sync="innerVisible"
            :before-close="handleInnerClose"
            append-to-body
          >
            <div v-if="dialogType == 1">
              <div class="dialog-title">
                <i
                  class="el-icon-success"
                  style="font-size: 40px; color: #409eff"
                ></i>
                <span class="title-text">手机扫一扫，请到手机端分享</span>
              </div>
              <div class="center-box">
                <div class="code">
                    <img :src="this.OrImage" class="QR-code" v-if="this.OrImage" />
                    <div class="tips">
                        打开微信[扫一扫]
                    </div>
                </div>
                <div class="alipay-code code" v-if="this.noaliqrcodeUrl.includes(this.host) == false">
                    <img :src="this.alipayOrImage" class="QR-code" v-if="this.alipayOrImage" />
                    <div class="tips">
                        打开支付宝[扫一扫]
                    </div>
                </div>
              </div>
            </div>
            <div v-if="dialogType == 2">
              <div class="center-box">
                {{ tabContent }}
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                @click="closeQRDialog"
                size="medium"
                :disabled="isCheck"
                >关闭
              </el-button>
            </div>
          </el-dialog>
          <div
            slot="footer"
            class="dialog-footer"
            style="text-align: center; margin-bottom: 20px"
          >
            <!-- <el-button @click="outerClose" size="medium">取 消</el-button> -->
            <el-button
              type="primary"
              @click="checkCategory"
              size="medium"
              :disabled="isCheck"
              >生成合作邀请码
            </el-button>
          </div>
        </el-dialog>

        <el-dialog
          width="40%"
          :title="'系统提示'"
          :close-on-click-modal="true"
          :visible.sync="qzFlag"
          append-to-body
        >
          <div class="dialog-title">
            <i
              class="el-icon-success"
              style="font-size: 40px; color: #409eff"
            ></i>
            <span class="title-text">请用户再次核对手写签章</span>
          </div>
          <div class="center-box">
            <img
              :src="this.OrImage_qz"
              class="QR-code"
              v-if="this.OrImage_qz"
            />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="qzFlag = false" size="medium"
              >关闭
            </el-button>
          </div>
        </el-dialog>

        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            v-if="buttonType == 'text'"
            width="160"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('customer_view') != -1"
                  @click="viewButton(scope.row.id)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-if="userPermissions.indexOf('customer_view') != -1"
                  @click="showXY(scope)"
                  >查看协议</el-button
                >
                <!-- <el-button size="mini" type="default" v-if="userPermissions.indexOf('customer_edit') != -1"  @click="editButton(scope.row.id)">编辑</el-button> -->
                <el-popover
                  v-if="userPermissions.indexOf('company_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible"
                >
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteButton(scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <!-- <el-button slot="reference" type="danger" size="mini">删除</el-button> -->
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
      <div class="people-btn-wrapper" v-if="this.is_import == 1 && !query.task_id">
        <el-button
          v-if="userPermissions.indexOf('customer_import') != -1"
          style="color: #1890ff"
          size="medium"
          @click="importExcel"
          icon="iconfont el-icon-upload"
          >人才Excel导入
        </el-button>
        <el-button
          type="text"
          size="medium"
          @click="
            mxGoUrl(
              mxGetOssUrl(
                '/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
                true
              )
            )
          "
        >
          人才导入模板.xlsx
        </el-button>
      </div>
	<!-- <signCompent ref="ref_sign"></signCompent> -->
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
//import signCompent from "./sign.vue";
import { mapGetters, mapState } from "vuex";
import store from '@/store'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
	//signCompent
  },
  data() {
    return {
      query:{},
      host:window.location.host,
      noaliqrcodeUrl:['khlztrz.51xinlong.com','www.ztrztd.com'],
      showLinkBtn:false,
      qyLinkForm:{
        mobile:'',
		url:''
      },
		is_E_sign:false,
	sign_downloadLoading:false,
      showDesc:false,
      is_show_djg:'',
      dialogPdfArr: [],
      dialogMultPdf: false,
      OrImage_qz: "",
      qzFlag: false,
      checkList: ["选中且禁用", "复选框 A"],
      //选择签约类型
      hidenumber: "****",
      options: [
        {
          id: "all",
          value: "全部",
        },
		{
		id: "esign",
		value: "E签宝",
		},
        {
          id: "import",
          value: "批量导入",
        },
        {
          id: "link",
          value: "链接签约",
        },
        // {
        //   id: 'qrcode',
        //   value: '二维码签约'
        // },
        {
          id: "openapi",
          value: "开放平台",
        },
      ],
      value: "",
      companyFormData: {
        category_id: [],
        name: [],
        missionContent: "",
      },
      categoryList: [],
      signUrl: "", //签约链接
      showQyLinkVisible:false,
      outerVisible: false, //外层模态框状态
      innerVisible: false, //内层模态框状态
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      searchCategory: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [
        {
          title: "ID",
          value: "id",
          width: 170,
          header_align: "center",
          align: "center",
        },
        {
          title: "姓名",
          width: 300,
          header_align: "center",
          /*  align: 'center', */
          value: [
            { label: "姓名：", value: "fullname" },
            { label: "性别：", value: "alias_sex" },
            { label: "生日：", value: "birthday" },
            { label: "qq：", value: "qq" },
            { label: "收款类型：", value: "alias_send_type" },
            { label: "银行账户：", value: "alias_bank_account_no" },
			{ label: "通道类型：", value: "yl_bank" },
          ],
        },
        {
          title: "证件号码",
          value: "id_number",
          header_align: "center",
          align: "center",
          // valueTemplate: '<span style="font-size:31px">{row}</span>',
          // valueTemplate: '<el-tag>{row}</el-tag>',
        },
        {
          title: "服务类型",
          value: "category_name",
          header_align: "center",
          align: "center",
        },
		{
		title: "本月已发放",
		value: "withdraw_money",
		header_align: "center",
		align: "center",
		},
        // {
        //   title: '身份证正面照片',
        //   header_align: 'center',
        //   align: 'center',
        //   type: 'image',
        //   value: 'id_img_positive',
        // },
        //  {
        //   title: '身份证反面照片',
        //   type: 'image',
        //   value: 'id_img_back',
        //   header_align: 'center',
        //   align: 'center',
        // },
        // {
        //   title: '签约类型',
        //   value: 'alias_sign_type',
        //   header_align: 'center',
        //   align: 'center',
        //  /*  width: 180 */
        // },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
          /*  width: 180 */
        },
      ],
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
        type: [{ required: true, message: "选择类型", trigger: "blur" }],
        is_new_win: [
          { required: true, message: "选择打开发方式", trigger: "blur" },
        ],
        is_show: [{ required: true, message: "选择状态", trigger: "blur" }],
        image: [
          {
            required: true,
            message: "上传图片",
            trigger: "blur",
            validator: this.apeUploaderVerify,
          },
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        // direction: 'right',
        title: "",
        width_height: "640px",
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList: [],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: "标题",
          value: "title",
        },
      ],
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 附件添加表单验证
      dialogRules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      isCheck: true, //是否禁用确定按钮
      category_Id: "",
      category_name: "",
      id: "",
      OrImage: "",
      alipayOrImage:'',
      is_import: "",
      exportOptions: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      //导出表格类型
      exportType: "xlsx",
      downloadLoading: false,
      exportSelect: "xlsx",
      dialogType: 1,
      tabContent:
        "邀请码生成成功！工作人员将在一个工作日内帮您进行任务描述审核。请勿重复提交，请耐心等待。",
      missionContentWarn: "*此处为非必填项，填写任务描述需进行一个工作日的审核",
      HSYSetIdArr:["2088150557908280","2088150558432364","2088150556615435","15386361220094","15332796690024","15089692280009","15218487080046"]
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
	async copyTextToClipboard(text) {
		try {
		await navigator.clipboard.writeText(text);
		} catch (err) {
		console.error('Failed to copy: ', err);
		}
	},
	copyLink(){
		this.copyTextToClipboard(this.qyLinkForm.url)
		this.$message.success("复制成功");
	},
	async event_searchLink(){
		if(!this.qyLinkForm.mobile){
			this.$message.warning("请输入手机号");
			return false
		}
		let args = {
			mobile:this.qyLinkForm.mobile
		}
		let res = await this.$api.getQyLink(args);
		this.qyLinkForm.url = res.url
		if(!res.url){
			this.$message.warning("暂无签约链接");
		}
	},
	showQyLink(){
		this.qyLinkForm = {
			mobile:'',
			url:''
		}
		this.showQyLinkVisible = !this.showQyLinkVisible
	},
    goPage(e) {
      this.mxPreview(e.sign_url);
    },
	async downFile  (pdfUrl,fileName)  {
	try {
	const res = await fetch(pdfUrl);
	if (!res.ok) {
	throw new Error(`Failed to fetch PDF: ${res.status} ${res.statusText}`);
	}
	const blob = await res.blob();
	const url = URL.createObjectURL(blob); // 传入用于创建 URL 的 File 对象、Blob,转换成浏览器可识别的blob格式
	console.log('url---',url); //blob:http://127.0.0.1:5500/f01dc675-8f01-4e47-9313-65b96321884f
	// 创建a标签，绑定href、download属性，添加在body，触发click事件
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName || 'downloaded.pdf';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link); // 移除元素
	URL.revokeObjectURL(url); // 当不再需要这些 URL 对象时,通过它释放掉
	} catch (error) {
	console.log(error)
	this.$message.error("提示："+fileName+"下载文件异常");
	}
	},
	//导出协议
	handleDownload_sign(){
		if(!this.is_E_sign){
			this.$message.warning("提示：仅E签宝类型支持批量导出");
			return 
		}
		this.sign_downloadLoading=true
		let i=0
		let timer=setInterval(()=>{
			if(i>this.companyList.length-1){
				this.sign_downloadLoading=false
				clearInterval(timer)
				return 
			}
			this.downFile(this.companyList[i].sign_url,this.companyList[i].id)
			i++
		},900)
		//console.log(this.companyList,this.$refs.ref_sign.exportPDF())
	},
    //查看协议
    async showXY(e) {
      let surl = "";
      if (e.row.sign_detail.length == 1) {
        surl = e.row.sign_detail[0].sign_url;
      } else if (e.row.sign_detail.length == 0) {
        surl = e.row.sign_url;
      } else {
        this.dialogPdfArr = e.row.sign_detail;
        this.dialogMultPdf = !this.dialogMultPdf;
        return false;
      }

      if (e.row.sign_status == 2) {
        let { id } = e.row;
        let param = {};
        param.id = id;
        console.log(param, "结果");
        let result = await this.$api.getQZinfo(param);
        console.log(result);
        let qzId = result;

        console.log(qzId);

        let str = "/pages/sign/draw";
        if (this.$config.domain.miniappPath) {
          str = this.$config.domain.miniappPath;
        }
        let path = `${str}?id=${qzId}`;
        let args = {
          path: path,
          appId: this.mxDomain.appId,
          id: id, //11/18传入
        };
        let res = await this.$api.createQrcode(args);
        if (res) {
          this.OrImage_qz = res;
          this.qzFlag = true;
        }
        return false;
      }
      if (e.row.sign_type == "esign" || e.row.sign_type == "receive_api" || (e.row.sign_type == "import" && e.row.sign_url) || (e.row.sign_type == "openapi" && e.row.sign_url)){
        this.mxPreview(e.row.sign_url);
      }else if(!e.row.sign_url && e.row.contract_url) {
          this.mxPreview(e.row.contract_url);
      }else {
          this.htmlToPdf(
            e.row.category_name,
            e.row.channel_name,
            e.row.company_name,
            e.row.created_at,
            surl,
            e.row.sign_type,
            e.row.fullname,
            e.row.id_number,
            e.row.channel_taxpayer,
            e.row.id
          );
      }
      
    },
    changeExportOption(e) {
      this.exportType = e;
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = {
          id: "【签约ID】",
          name: "【姓名】",
          cardType: "【证件类型(1:身份证2:港澳台通行证3：护照4：军官证)】",
          idCard: "【身份证号码】",
          phone: "【手机号码】",
          bankCard: "【账号(银行卡号或支付宝邮箱账号)】",
          type: "【下发类型(OTHERBANK:银行卡;ALIPAY:支付宝)】",
          categoryName: "【签约类型】",
          companyName: "【公司名称】",
          channelName: "【服务公司名称】",
          createdAt: "【创建时间】",
        };
        const data = this.formatJson(list);
        data.unshift(Object.values(sHeader));
        console.log(data, "data");
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `人才签约${time}`;
        excel.export_json_to_excel({
          header: Object.keys(sHeader), //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          id,
          fullname,
          id_number,
          mobile,
          bank_account_no,
          send_type,
          category_name,
          company_name,
          channel_name,
          created_at,
        } = v;
        return [
          id,
          fullname,
          1,
          id_number,
          mobile,
          bank_account_no,
          send_type,
          category_name,
          company_name,
          channel_name,
          created_at,
        ];
      });
    },
    //获取支持批量人才状态
    async isImport() {
      let args = {
        companyId: this.$route.params.company_id,
      };
      let result = await this.$api.isImport(args);
      if (result) {
        this.is_import = result.is_import;
		console.log("this.is_import", this.is_import);
		this.is_show_djg = result.is_show_djg;
		if(this.is_show_djg==1){
			let columns = this.columns;
				columns.splice(4,0, {
				title: "董监高人群",
				value: "is_show_djg",
				header_align: "center",
				align: "center"
            })
		this.columns = columns;
		}
      }
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.outerVisible = false;
      this.innerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
      };
    },
    htmlToPdf(
      category_name,
      channel_name,
      company_name,
      created_at,
      sign_url,
      sign_type,
      fullname,
      id_number,
      channel_taxpayer,
      id
    ) {
      if (['tomato','esign'].includes(sign_type)) {
        this.mxPreview(sign_url);
      } else {
		let path = '/customer/exportpdf'
		if(this.HSYSetIdArr.includes(this.mxSettlementId)){
			path = '/customer/exportpdf-HSY'
		}
        let routeData = this.$router.resolve({
          path,
          query: {
            category_name,
            channel_name,
            company_name,
            created_at,
            sign_url,
            sign_type,
            fullname,
            id_number,
            channel_taxpayer,id
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    //复选框选择时间
    handleTaskChange(val) {
      if (val) {
        this.isCheck = false;
        this.categoryList.find((value) => {
          this.companyFormData.name.forEach((item, index) => {
            if (item == value.name) {
              this.companyFormData.name[index] = value.name;
              this.companyFormData.category_id[index] = value.id;
            }
          });
        });
        this.category_Id = this.companyFormData.category_id.join("、");
        this.category_name = this.companyFormData.name.join("、");
        const { company_id, settlement_id } = this.userInfo;
        this.signUrl = encodeURI(
          `/pages/projectsign/projectsign?companyId=${company_id}&settlementId=${settlement_id}&categoryId=${this.category_Id}&categoryName=${this.category_name}&location=${this.mxDomain.location}`
        );
      }
    },
    //获取签约链接
    async cusomerLink() {
      this.categoryList = await this.$api.getCustomerCategoryList();
      this.outerVisible = true;
    },
    //关闭内层小dialog×
    handleInnerClose() {
      this.innerVisible = false;
      this.OrImage = '';
      this.alipayOrImage = '';
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.outerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
      };
    },
    // //取消外层dialog
    // outerClose() {
    //   this.outerVisible = false;
    //   this.companyFormData = {
    //     category_id: [],
    //     name: []
    //   };
    // },
    //取消内层dialog
    innerClose() {
      this.innerVisible = false;
    },
    checkCategory() {
      if (this.companyFormData.category_id != "") {
        this.getQRCode();
      }
    },
    // 创建二维码
    async createQrCode(id) {
      let str = "/pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        str = this.$config.domain.miniappPath;
      }
      let path = `${str}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`;
      let args = {
        path: path,
        appId: this.mxDomain.appId,
        id: id,
      };
      let res = await this.$api.createQrcode(args);
      if (res) {
        this.OrImage = res;
      }
    },
    async createAlipayQrCode(id) {
      let str = "pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        str = this.$config.domain.miniappPath;
      }
      console.log(this.mxDomain,'this.mxDomain')
      let path = `${str}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`;
      let args = {
        path: path,
        query_param:`id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`,
        describe:"扫描此二维码",
        appId: this.mxDomain.alipayAppId,
        id: id,
      };
      let res = await this.$api.createQrcode(args);
      if (res) {
        this.alipayOrImage = res;
      }
    },
    async getQRCode() {
      let nameList = [],
        names,
        remark,
        name;
      this.companyFormData.name.forEach((item) => {
        nameList.push(item.substring(0, item.length - 2));
      });
      names = nameList.join("、");
      name = `${names}`;
      remark = `因委托方业务发展，现需要若干有相关服务经验或能力的自由职业者提供${this.companyFormData.name.join(
        "、"
      )}，具体要求和费用由委托方公布。`;
      let args = {
        name,
        remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、"),
        mission_content: this.companyFormData.missionContent ?? "",
      };
      let res = await this.$api.getQRCode(args);
      if (res) {
        this.innerVisible = true;
        if (this.companyFormData.missionContent == "") {
          this.dialogType = 1;
        } else {
          this.dialogType = 2;
        }
        this.createQrCode(res);
        if(this.mxDomain.appId=='1004' || this.mxDomain.appId=='1001'){
            this.createAlipayQrCode(res);
        }
      }
    },

    // //去h5签约
    // goSign() {
    //   this.companyFormData = {
    //     category_id: [],
    //     name: []
    //   };
    //   this.isCheck = true
    //   this.innerVisible = false;
    //   this.outerVisible = false;
    // },
    // 搜索
    searchButton() {
		this.is_E_sign=this.searchCondition.sign_type==='esign'
      this.init("search");
    },
    //导入跳转
    importExcel() {
      this.$router.push({ path: "customer/import" });
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id);
      this.$router.push(this.$route.path + "/" + id + "/view");
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id);
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id);
      let info = await this.$api.deleteCustomer(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.init("del");
        });
      } else {
        this.$message.error(info);
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      if (searchCondition.sign_type == "all") {
        delete searchCondition.sign_type;
      }
      Object.assign(searchCondition, pagingInfo);

      if (searchCondition.sign_type == "status_error") {
        delete searchCondition.sign_type;
        searchCondition.sign_status = 2;
      }


      if(this.query && this.query.task_id){
        searchCondition.task_id = this.query.task_id
        searchCondition.task_type = this.query.task_type
      }

      let { list, pages } = await this.$api.getCustomerList(searchCondition);
      // 对身份证进行处理
      list.map((item) => {
			item.is_show_djg = '否'
        // item.id_number = item.id_number.replace(
        //   item.id_number.substring(0, 4),
        //   "****"
        // );

        // item.id_number = item.id_number.replace(
        //   item.id_number.substring(item.id_number.length-4, item.id_number.length),
        //   "****"
        // );
      });

      if (type == "export") {
        this.loadingStaus = false;
        return list;
      } else {
        this.companyList = [];

        this.$nextTick(() => {
          this.companyList = list;
        });
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },

    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.fullname) {
        condition.fullname = this.searchCondition.fullname;
      }
      if (this.searchCondition.sign_type) {
        condition.sign_type = this.searchCondition.sign_type;
      }
      if (this.searchCondition.id_number) {
        condition.id_number = this.searchCondition.id_number;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = "正在提交中……";
      this.dialogData.loading = true;
      this.formData.company_id = this.currentCompanyId;
      let id = await this.$api.saveCompanyAttachment(this.formData);
      this.$nextTick(() => {
        this.dialogClose();
      });
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList();
        }
      });
      this.$nextTick(() => {
        this.$message.success("保存成功!");
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyAttacmentForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      this.dialogData.loading = true;
      this.formData = {};
      this.attachmentUploadFileList = [];
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true;
      this.dialogData.loading = false;
      this.dialogData.title = "添加附件";
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.initCompanyAttachmentList();
        });
      } else {
        this.$message.error(info);
      }
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    // let { company_id, settlement_id } = this.userInfo
    this.keyupSubmit();
  },
  mounted() {
    this.query = this.$route.query
    this.init();
    this.isImport();
	const { ename } = store.state.domainInfo
	if(ename == 'khlyuecai'){
		this.showLinkBtn = true
	}
  },
};
</script>

<style lang="scss" scoped>
.qyLinkArea{
	display: flex;
	flex-direction: row;
	.linkurl{
		color: #55aaff;
		&-nodata{
			color: #999498;
		}
	}
}
.searchBtnQYLink{
	margin-left: 20px;
}
.item-mobile{
	width: 240px;
}
.mainPDF {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.mainPDF label {
  margin-bottom: 10px;
}

/deep/ .el-checkbox-group label {
  width: 180px;
}

/deep/ .el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/ .el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 160px;
}

.cusomer-link-search {
  position: absolute;
  top: 0;
  left: 180px;
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.code{
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    height: 200px;
    overflow: hidden;
    &.alipay-code{
        margin-left: 30px;
        position: relative;
        .QR-code{
            position: relative;
            top: -30px;
            width: 220px;
            height: 220px;
        }
        .tips{
            position: absolute;
            bottom: 0;
        }
    }
    .tips{
        margin-top: 10px;
        font-size: 14px;
        color: #333;
    }
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
